const entities = [
  [" ", "0020", "SPACE"],
  ["!", "0021", "EXCLAMATION MARK"],
  ['"', "0022", "QUOTATION MARK"],
  ["#", "0023", "NUMBER SIGN"],
  ["$", "0024", "DOLLAR SIGN"],
  ["%", "0025", "PERCENT SIGN"],
  ["&", "0026", "AMPERSAND"],
  ["'", "0027", "APOSTROPHE"],
  ["(", "0028", "LEFT PARENTHESIS"],
  [")", "0029", "RIGHT PARENTHESIS"],
  ["*", "002A", "ASTERISK"],
  ["+", "002B", "PLUS SIGN"],
  [",", "002C", "COMMA"],
  ["-", "002D", "HYPHEN-MINUS"],
  [".", "002E", "FULL STOP"],
  ["/", "002F", "SOLIDUS"],
  ["0", "0030", "DIGIT ZERO"],
  ["1", "0031", "DIGIT ONE"],
  ["2", "0032", "DIGIT TWO"],
  ["3", "0033", "DIGIT THREE"],
  ["4", "0034", "DIGIT FOUR"],
  ["5", "0035", "DIGIT FIVE"],
  ["6", "0036", "DIGIT SIX"],
  ["7", "0037", "DIGIT SEVEN"],
  ["8", "0038", "DIGIT EIGHT"],
  ["9", "0039", "DIGIT NINE"],
  [":", "003A", "COLON"],
  [";", "003B", "SEMICOLON"],
  ["<", "003C", "LESS-THAN SIGN"],
  ["=", "003D", "EQUALS SIGN"],
  [">", "003E", "GREATER-THAN SIGN"],
  ["?", "003F", "QUESTION MARK"],
  ["@", "0040", "COMMERCIAL AT"],
  ["A", "0041", "LATIN CAPITAL LETTER A"],
  ["B", "0042", "LATIN CAPITAL LETTER B"],
  ["C", "0043", "LATIN CAPITAL LETTER C"],
  ["D", "0044", "LATIN CAPITAL LETTER D"],
  ["E", "0045", "LATIN CAPITAL LETTER E"],
  ["F", "0046", "LATIN CAPITAL LETTER F"],
  ["G", "0047", "LATIN CAPITAL LETTER G"],
  ["H", "0048", "LATIN CAPITAL LETTER H"],
  ["I", "0049", "LATIN CAPITAL LETTER I"],
  ["J", "004A", "LATIN CAPITAL LETTER J"],
  ["K", "004B", "LATIN CAPITAL LETTER K"],
  ["L", "004C", "LATIN CAPITAL LETTER L"],
  ["M", "004D", "LATIN CAPITAL LETTER M"],
  ["N", "004E", "LATIN CAPITAL LETTER N"],
  ["O", "004F", "LATIN CAPITAL LETTER O"],
  ["P", "0050", "LATIN CAPITAL LETTER P"],
  ["Q", "0051", "LATIN CAPITAL LETTER Q"],
  ["R", "0052", "LATIN CAPITAL LETTER R"],
  ["S", "0053", "LATIN CAPITAL LETTER S"],
  ["T", "0054", "LATIN CAPITAL LETTER T"],
  ["U", "0055", "LATIN CAPITAL LETTER U"],
  ["V", "0056", "LATIN CAPITAL LETTER V"],
  ["W", "0057", "LATIN CAPITAL LETTER W"],
  ["X", "0058", "LATIN CAPITAL LETTER X"],
  ["Y", "0059", "LATIN CAPITAL LETTER Y"],
  ["Z", "005A", "LATIN CAPITAL LETTER Z"],
  ["[", "005B", "LEFT SQUARE BRACKET"],
  ["\\", "005C", "REVERSE SOLIDUS"],
  ["]", "005D", "RIGHT SQUARE BRACKET"],
  ["^", "005E", "CIRCUMFLEX ACCENT"],
  ["_", "005F", "LOW LINE"],
  ["`", "0060", "GRAVE ACCENT"],
  ["a", "0061", "LATIN SMALL LETTER A"],
  ["b", "0062", "LATIN SMALL LETTER B"],
  ["c", "0063", "LATIN SMALL LETTER C"],
  ["d", "0064", "LATIN SMALL LETTER D"],
  ["e", "0065", "LATIN SMALL LETTER E"],
  ["f", "0066", "LATIN SMALL LETTER F"],
  ["g", "0067", "LATIN SMALL LETTER G"],
  ["h", "0068", "LATIN SMALL LETTER H"],
  ["i", "0069", "LATIN SMALL LETTER I"],
  ["j", "006A", "LATIN SMALL LETTER J"],
  ["k", "006B", "LATIN SMALL LETTER K"],
  ["l", "006C", "LATIN SMALL LETTER L"],
  ["m", "006D", "LATIN SMALL LETTER M"],
  ["n", "006E", "LATIN SMALL LETTER N"],
  ["o", "006F", "LATIN SMALL LETTER O"],
  ["p", "0070", "LATIN SMALL LETTER P"],
  ["q", "0071", "LATIN SMALL LETTER Q"],
  ["r", "0072", "LATIN SMALL LETTER R"],
  ["s", "0073", "LATIN SMALL LETTER S"],
  ["t", "0074", "LATIN SMALL LETTER T"],
  ["u", "0075", "LATIN SMALL LETTER U"],
  ["v", "0076", "LATIN SMALL LETTER V"],
  ["w", "0077", "LATIN SMALL LETTER W"],
  ["x", "0078", "LATIN SMALL LETTER X"],
  ["y", "0079", "LATIN SMALL LETTER Y"],
  ["z", "007A", "LATIN SMALL LETTER Z"],

  ["{", "007B", "LEFT CURLY BRACKET"],
  ["|", "007C", "VERTICAL LINE"],
  ["}", "007D", "RIGHT CURLY BRACKET"],
  ["~", "007E", "TILDE"],
  ["\u00A0", "00A0", "NO-BREAK SPACE"],
  ["¡", "00A1", "INVERTED EXCLAMATION MARK"],
  ["¢", "00A2", "CENT SIGN"],
  ["£", "00A3", "POUND SIGN"],
  ["¤", "00A4", "CURRENCY SIGN"],
  ["¥", "00A5", "YEN SIGN"],
  ["¦", "00A6", "BROKEN BAR"],
  ["§", "00A7", "SECTION SIGN"],
  ["¨", "00A8", "DIAERESIS"],
  ["©", "00A9", "COPYRIGHT SIGN"],
  ["ª", "00AA", "FEMININE ORDINAL INDICATOR"],
  ["«", "00AB", "LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"],
  ["¬", "00AC", "NOT SIGN"],
  ["­", "00AD", "SOFT HYPHEN"],
  ["®", "00AE", "REGISTERED SIGN"],
  ["¯", "00AF", "MACRON"],
  ["°", "00B0", "DEGREE SIGN"],
  ["±", "00B1", "PLUS-MINUS SIGN"],
  ["²", "00B2", "SUPERSCRIPT TWO"],
  ["³", "00B3", "SUPERSCRIPT THREE"],
  ["´", "00B4", "ACUTE ACCENT"],
  ["µ", "00B5", "MICRO SIGN"],
  ["¶", "00B6", "PILCROW SIGN"],
  ["·", "00B7", "MIDDLE DOT"],
  ["¸", "00B8", "CEDILLA"],
  ["¹", "00B9", "SUPERSCRIPT ONE"],
  ["º", "00BA", "MASCULINE ORDINAL INDICATOR"],
  ["»", "00BB", "RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"],
  ["¼", "00BC", "VULGAR FRACTION ONE QUARTER"],
  ["½", "00BD", "VULGAR FRACTION ONE HALF"],
  ["¾", "00BE", "VULGAR FRACTION THREE QUARTERS"],
  ["¿", "00BF", "INVERTED QUESTION MARK"],
  ["À", "00C0", "LATIN CAPITAL LETTER A WITH GRAVE"],
  ["Á", "00C1", "LATIN CAPITAL LETTER A WITH ACUTE"],
  ["Â", "00C2", "LATIN CAPITAL LETTER A WITH CIRCUMFLEX"],
  ["Ã", "00C3", "LATIN CAPITAL LETTER A WITH TILDE"],
  ["Ä", "00C4", "LATIN CAPITAL LETTER A WITH DIAERESIS"],
  ["Å", "00C5", "LATIN CAPITAL LETTER A WITH RING ABOVE"],
  ["Æ", "00C6", "LATIN CAPITAL LETTER AE"],
  ["Ç", "00C7", "LATIN CAPITAL LETTER C WITH CEDILLA"],
  ["È", "00C8", "LATIN CAPITAL LETTER E WITH GRAVE"],
  ["É", "00C9", "LATIN CAPITAL LETTER E WITH ACUTE"],
  ["Ê", "00CA", "LATIN CAPITAL LETTER E WITH CIRCUMFLEX"],
  ["Ë", "00CB", "LATIN CAPITAL LETTER E WITH DIAERESIS"],
  ["Ì", "00CC", "LATIN CAPITAL LETTER I WITH GRAVE"],
  ["Í", "00CD", "LATIN CAPITAL LETTER I WITH ACUTE"],
  ["Î", "00CE", "LATIN CAPITAL LETTER I WITH CIRCUMFLEX"],
  ["Ï", "00CF", "LATIN CAPITAL LETTER I WITH DIAERESIS"],
  ["Ð", "00D0", "LATIN CAPITAL LETTER ETH"],
  ["Ñ", "00D1", "LATIN CAPITAL LETTER N WITH TILDE"],
  ["Ò", "00D2", "LATIN CAPITAL LETTER O WITH GRAVE"],
  ["Ó", "00D3", "LATIN CAPITAL LETTER O WITH ACUTE"],
  ["Ô", "00D4", "LATIN CAPITAL LETTER O WITH CIRCUMFLEX"],
  ["Õ", "00D5", "LATIN CAPITAL LETTER O WITH TILDE"],
  ["Ö", "00D6", "LATIN CAPITAL LETTER O WITH DIAERESIS"],
  ["×", "00D7", "MULTIPLICATION SIGN"],
  ["Ø", "00D8", "LATIN CAPITAL LETTER O WITH STROKE"],
  ["Ù", "00D9", "LATIN CAPITAL LETTER U WITH GRAVE"],
  ["Ú", "00DA", "LATIN CAPITAL LETTER U WITH ACUTE"],
  ["Û", "00DB", "LATIN CAPITAL LETTER U WITH CIRCUMFLEX"],
  ["Ü", "00DC", "LATIN CAPITAL LETTER U WITH DIAERESIS"],
  ["Ý", "00DD", "LATIN CAPITAL LETTER Y WITH ACUTE"],
  ["Þ", "00DE", "LATIN CAPITAL LETTER THORN"],
  ["ß", "00DF", "LATIN SMALL LETTER SHARP S"],
  ["à", "00E0", "LATIN SMALL LETTER A WITH GRAVE"],
  ["á", "00E1", "LATIN SMALL LETTER A WITH ACUTE"],
  ["â", "00E2", "LATIN SMALL LETTER A WITH CIRCUMFLEX"],
  ["ã", "00E3", "LATIN SMALL LETTER A WITH TILDE"],
  ["ä", "00E4", "LATIN SMALL LETTER A WITH DIAERESIS"],
  ["å", "00E5", "LATIN SMALL LETTER A WITH RING ABOVE"],
  ["æ", "00E6", "LATIN SMALL LETTER AE"],
  ["ç", "00E7", "LATIN SMALL LETTER C WITH CEDILLA"],
  ["è", "00E8", "LATIN SMALL LETTER E WITH GRAVE"],
  ["é", "00E9", "LATIN SMALL LETTER E WITH ACUTE"],
  ["ê", "00EA", "LATIN SMALL LETTER E WITH CIRCUMFLEX"],
  ["ë", "00EB", "LATIN SMALL LETTER E WITH DIAERESIS"],
  ["ì", "00EC", "LATIN SMALL LETTER I WITH GRAVE"],
  ["í", "00ED", "LATIN SMALL LETTER I WITH ACUTE"],
  ["î", "00EE", "LATIN SMALL LETTER I WITH CIRCUMFLEX"],
  ["ï", "00EF", "LATIN SMALL LETTER I WITH DIAERESIS"],
  ["ð", "00F0", "LATIN SMALL LETTER ETH"],
  ["ñ", "00F1", "LATIN SMALL LETTER N WITH TILDE"],
  ["ò", "00F2", "LATIN SMALL LETTER O WITH GRAVE"],
  ["ó", "00F3", "LATIN SMALL LETTER O WITH ACUTE"],
  ["ô", "00F4", "LATIN SMALL LETTER O WITH CIRCUMFLEX"],
  ["õ", "00F5", "LATIN SMALL LETTER O WITH TILDE"],
  ["ö", "00F6", "LATIN SMALL LETTER O WITH DIAERESIS"],
  ["÷", "00F7", "DIVISION SIGN"],
  ["ø", "00F8", "LATIN SMALL LETTER O WITH STROKE"],
  ["ù", "00F9", "LATIN SMALL LETTER U WITH GRAVE"],
  ["ú", "00FA", "LATIN SMALL LETTER U WITH ACUTE"],
  ["û", "00FB", "LATIN SMALL LETTER U WITH CIRCUMFLEX"],
  ["ü", "00FC", "LATIN SMALL LETTER U WITH DIAERESIS"],
  ["ý", "00FD", "LATIN SMALL LETTER Y WITH ACUTE"],
  ["þ", "00FE", "LATIN SMALL LETTER THORN"],
  ["ÿ", "00FF", "LATIN SMALL LETTER Y WITH DIAERESIS"],
  ["Ā", "0100", "LATIN CAPITAL LETTER A WITH MACRON"],
  ["ā", "0101", "LATIN SMALL LETTER A WITH MACRON"],
  ["Ă", "0102", "LATIN CAPITAL LETTER A WITH BREVE"],
  ["ă", "0103", "LATIN SMALL LETTER A WITH BREVE"],
  ["Ą", "0104", "LATIN CAPITAL LETTER A WITH OGONEK"],
  ["ą", "0105", "LATIN SMALL LETTER A WITH OGONEK"],
  ["Ć", "0106", "LATIN CAPITAL LETTER C WITH ACUTE"],
  ["ć", "0107", "LATIN SMALL LETTER C WITH ACUTE"],
  ["Ĉ", "0108", "LATIN CAPITAL LETTER C WITH CIRCUMFLEX"],
  ["ĉ", "0109", "LATIN SMALL LETTER C WITH CIRCUMFLEX"],
  ["Ċ", "010A", "LATIN CAPITAL LETTER C WITH DOT ABOVE"],
  ["ċ", "010B", "LATIN SMALL LETTER C WITH DOT ABOVE"],
  ["Č", "010C", "LATIN CAPITAL LETTER C WITH CARON"],
  ["č", "010D", "LATIN SMALL LETTER C WITH CARON"],
  ["Ď", "010E", "LATIN CAPITAL LETTER D WITH CARON"],
  ["ď", "010F", "LATIN SMALL LETTER D WITH CARON"],
  ["Đ", "0110", "LATIN CAPITAL LETTER D WITH STROKE"],
  ["đ", "0111", "LATIN SMALL LETTER D WITH STROKE"],
  ["Ē", "0112", "LATIN CAPITAL LETTER E WITH MACRON"],
  ["ē", "0113", "LATIN SMALL LETTER E WITH MACRON"],
  ["Ĕ", "0114", "LATIN CAPITAL LETTER E WITH BREVE"],
  ["ĕ", "0115", "LATIN SMALL LETTER E WITH BREVE"],
  ["Ė", "0116", "LATIN CAPITAL LETTER E WITH DOT ABOVE"],
  ["ė", "0117", "LATIN SMALL LETTER E WITH DOT ABOVE"],
  ["Ę", "0118", "LATIN CAPITAL LETTER E WITH OGONEK"],
  ["ę", "0119", "LATIN SMALL LETTER E WITH OGONEK"],
  ["Ě", "011A", "LATIN CAPITAL LETTER E WITH CARON"],
  ["ě", "011B", "LATIN SMALL LETTER E WITH CARON"],
  ["Ĝ", "011C", "LATIN CAPITAL LETTER G WITH CIRCUMFLEX"],
  ["ĝ", "011D", "LATIN SMALL LETTER G WITH CIRCUMFLEX"],
  ["Ğ", "011E", "LATIN CAPITAL LETTER G WITH BREVE"],
  ["ğ", "011F", "LATIN SMALL LETTER G WITH BREVE"],
  ["Ġ", "0120", "LATIN CAPITAL LETTER G WITH DOT ABOVE"],
  ["ġ", "0121", "LATIN SMALL LETTER G WITH DOT ABOVE"],
  ["Ģ", "0122", "LATIN CAPITAL LETTER G WITH CEDILLA"],
  ["ģ", "0123", "LATIN SMALL LETTER G WITH CEDILLA"],
  ["Ĥ", "0124", "LATIN CAPITAL LETTER H WITH CIRCUMFLEX"],
  ["ĥ", "0125", "LATIN SMALL LETTER H WITH CIRCUMFLEX"],
  ["Ħ", "0126", "LATIN CAPITAL LETTER H WITH STROKE"],
  ["ħ", "0127", "LATIN SMALL LETTER H WITH STROKE"],
  ["Ĩ", "0128", "LATIN CAPITAL LETTER I WITH TILDE"],
  ["ĩ", "0129", "LATIN SMALL LETTER I WITH TILDE"],
  ["Ī", "012A", "LATIN CAPITAL LETTER I WITH MACRON"],
  ["ī", "012B", "LATIN SMALL LETTER I WITH MACRON"],
  ["Ĭ", "012C", "LATIN CAPITAL LETTER I WITH BREVE"],
  ["ĭ", "012D", "LATIN SMALL LETTER I WITH BREVE"],
  ["Į", "012E", "LATIN CAPITAL LETTER I WITH OGONEK"],
  ["į", "012F", "LATIN SMALL LETTER I WITH OGONEK"],
  ["İ", "0130", "LATIN CAPITAL LETTER I WITH DOT ABOVE"],
  ["ı", "0131", "LATIN SMALL LETTER DOTLESS I"],

  ["Ĳ", "0132", "LATIN CAPITAL LIGATURE IJ"],
  ["ĳ", "0133", "LATIN SMALL LIGATURE IJ"],
  ["Ĵ", "0134", "LATIN CAPITAL LETTER J WITH CIRCUMFLEX"],
  ["ĵ", "0135", "LATIN SMALL LETTER J WITH CIRCUMFLEX"],
  ["Ķ", "0136", "LATIN CAPITAL LETTER K WITH CEDILLA"],
  ["ķ", "0137", "LATIN SMALL LETTER K WITH CEDILLA"],
  ["ĸ", "0138", "LATIN SMALL LETTER KRA"],
  ["Ĺ", "0139", "LATIN CAPITAL LETTER L WITH ACUTE"],
  ["ĺ", "013A", "LATIN SMALL LETTER L WITH ACUTE"],
  ["Ļ", "013B", "LATIN CAPITAL LETTER L WITH CEDILLA"],
  ["ļ", "013C", "LATIN SMALL LETTER L WITH CEDILLA"],
  ["Ľ", "013D", "LATIN CAPITAL LETTER L WITH CARON"],
  ["ľ", "013E", "LATIN SMALL LETTER L WITH CARON"],
  ["Ŀ", "013F", "LATIN CAPITAL LETTER L WITH MIDDLE DOT"],
  ["ŀ", "0140", "LATIN SMALL LETTER L WITH MIDDLE DOT"],
  ["Ł", "0141", "LATIN CAPITAL LETTER L WITH STROKE"],
  ["ł", "0142", "LATIN SMALL LETTER L WITH STROKE"],
  ["Ń", "0143", "LATIN CAPITAL LETTER N WITH ACUTE"],
  ["ń", "0144", "LATIN SMALL LETTER N WITH ACUTE"],
  ["Ņ", "0145", "LATIN CAPITAL LETTER N WITH CEDILLA"],
  ["ņ", "0146", "LATIN SMALL LETTER N WITH CEDILLA"],
  ["Ň", "0147", "LATIN CAPITAL LETTER N WITH CARON"],
  ["ň", "0148", "LATIN SMALL LETTER N WITH CARON"],
  ["ŉ", "0149", "LATIN SMALL LETTER N PRECEDED BY APOSTROPHE"],
  ["Ŋ", "014A", "LATIN CAPITAL LETTER ENG"],
  ["ŋ", "014B", "LATIN SMALL LETTER ENG"],
  ["Ō", "014C", "LATIN CAPITAL LETTER O WITH MACRON"],
  ["ō", "014D", "LATIN SMALL LETTER O WITH MACRON"],
  ["Ŏ", "014E", "LATIN CAPITAL LETTER O WITH BREVE"],
  ["ŏ", "014F", "LATIN SMALL LETTER O WITH BREVE"],
  ["Ő", "0150", "LATIN CAPITAL LETTER O WITH DOUBLE ACUTE"],
  ["ő", "0151", "LATIN SMALL LETTER O WITH DOUBLE ACUTE"],
  ["Œ", "0152", "LATIN CAPITAL LIGATURE OE"],
  ["œ", "0153", "LATIN SMALL LIGATURE OE"],
  ["Ŕ", "0154", "LATIN CAPITAL LETTER R WITH ACUTE"],
  ["ŕ", "0155", "LATIN SMALL LETTER R WITH ACUTE"],
  ["Ŗ", "0156", "LATIN CAPITAL LETTER R WITH CEDILLA"],
  ["ŗ", "0157", "LATIN SMALL LETTER R WITH CEDILLA"],
  ["Ř", "0158", "LATIN CAPITAL LETTER R WITH CARON"],
  ["ř", "0159", "LATIN SMALL LETTER R WITH CARON"],
  ["Ś", "015A", "LATIN CAPITAL LETTER S WITH ACUTE"],
  ["ś", "015B", "LATIN SMALL LETTER S WITH ACUTE"],
  ["Ŝ", "015C", "LATIN CAPITAL LETTER S WITH CIRCUMFLEX"],
  ["ŝ", "015D", "LATIN SMALL LETTER S WITH CIRCUMFLEX"],
  ["Ş", "015E", "LATIN CAPITAL LETTER S WITH CEDILLA"],
  ["ş", "015F", "LATIN SMALL LETTER S WITH CEDILLA"],
  ["Š", "0160", "LATIN CAPITAL LETTER S WITH CARON"],
  ["š", "0161", "LATIN SMALL LETTER S WITH CARON"],
  ["Ţ", "0162", "LATIN CAPITAL LETTER T WITH CEDILLA"],
  ["ţ", "0163", "LATIN SMALL LETTER T WITH CEDILLA"],
  ["Ť", "0164", "LATIN CAPITAL LETTER T WITH CARON"],
  ["ť", "0165", "LATIN SMALL LETTER T WITH CARON"],
  ["Ŧ", "0166", "LATIN CAPITAL LETTER T WITH STROKE"],
  ["ŧ", "0167", "LATIN SMALL LETTER T WITH STROKE"],
  ["Ũ", "0168", "LATIN CAPITAL LETTER U WITH TILDE"],
  ["ũ", "0169", "LATIN SMALL LETTER U WITH TILDE"],
  ["Ū", "016A", "LATIN CAPITAL LETTER U WITH MACRON"],
  ["ū", "016B", "LATIN SMALL LETTER U WITH MACRON"],
  ["Ŭ", "016C", "LATIN CAPITAL LETTER U WITH BREVE"],
  ["ŭ", "016D", "LATIN SMALL LETTER U WITH BREVE"],
  ["Ů", "016E", "LATIN CAPITAL LETTER U WITH RING ABOVE"],
  ["ů", "016F", "LATIN SMALL LETTER U WITH RING ABOVE"],
  ["Ű", "0170", "LATIN CAPITAL LETTER U WITH DOUBLE ACUTE"],
  ["ű", "0171", "LATIN SMALL LETTER U WITH DOUBLE ACUTE"],
  ["Ų", "0172", "LATIN CAPITAL LETTER U WITH OGONEK"],
  ["ų", "0173", "LATIN SMALL LETTER U WITH OGONEK"],
  ["Ŵ", "0174", "LATIN CAPITAL LETTER W WITH CIRCUMFLEX"],
  ["ŵ", "0175", "LATIN SMALL LETTER W WITH CIRCUMFLEX"],
  ["Ŷ", "0176", "LATIN CAPITAL LETTER Y WITH CIRCUMFLEX"],
  ["ŷ", "0177", "LATIN SMALL LETTER Y WITH CIRCUMFLEX"],
  ["Ÿ", "0178", "LATIN CAPITAL LETTER Y WITH DIAERESIS"],
  ["Ź", "0179", "LATIN CAPITAL LETTER Z WITH ACUTE"],
  ["ź", "017A", "LATIN SMALL LETTER Z WITH ACUTE"],
  ["Ż", "017B", "LATIN CAPITAL LETTER Z WITH DOT ABOVE"],
  ["ż", "017C", "LATIN SMALL LETTER Z WITH DOT ABOVE"],
  ["Ž", "017D", "LATIN CAPITAL LETTER Z WITH CARON"],
  ["ž", "017E", "LATIN SMALL LETTER Z WITH CARON"],
  ["ſ", "017F", "LATIN SMALL LETTER LONG S"],

  ["ƀ", "0180", "LATIN SMALL LETTER B WITH STROKE"],
  ["Ɓ", "0181", "LATIN CAPITAL LETTER B WITH HOOK"],
  ["Ƃ", "0182", "LATIN CAPITAL LETTER B WITH TOPBAR"],
  ["ƃ", "0183", "LATIN SMALL LETTER B WITH TOPBAR"],
  ["Ƅ", "0184", "LATIN CAPITAL LETTER TONE SIX"],
  ["ƅ", "0185", "LATIN SMALL LETTER TONE SIX"],
  ["Ɔ", "0186", "LATIN CAPITAL LETTER OPEN O"],
  ["Ƈ", "0187", "LATIN CAPITAL LETTER C WITH HOOK"],
  ["ƈ", "0188", "LATIN SMALL LETTER C WITH HOOK"],
  ["Ɖ", "0189", "LATIN CAPITAL LETTER AFRICAN D"],
  ["Ɗ", "018A", "LATIN CAPITAL LETTER D WITH HOOK"],
  ["Ƌ", "018B", "LATIN CAPITAL LETTER D WITH TOPBAR"],
  ["ƌ", "018C", "LATIN SMALL LETTER D WITH TOPBAR"],
  ["ƍ", "018D", "LATIN SMALL LETTER TURNED DELTA"],
  ["Ǝ", "018E", "LATIN CAPITAL LETTER REVERSED E"],
  ["Ə", "018F", "LATIN CAPITAL LETTER SCHWA"],
  ["Ɛ", "0190", "LATIN CAPITAL LETTER OPEN E"],
  ["Ƒ", "0191", "LATIN CAPITAL LETTER F WITH HOOK"],
  ["ƒ", "0192", "LATIN SMALL LETTER F WITH HOOK"],
  ["Ɠ", "0193", "LATIN CAPITAL LETTER G WITH HOOK"],
  ["Ɣ", "0194", "LATIN CAPITAL LETTER GAMMA"],
  ["ƕ", "0195", "LATIN SMALL LETTER HV"],
  ["Ɩ", "0196", "LATIN CAPITAL LETTER IOTA"],
  ["Ɨ", "0197", "LATIN CAPITAL LETTER I WITH STROKE"],
  ["Ƙ", "0198", "LATIN CAPITAL LETTER K WITH HOOK"],
  ["ƙ", "0199", "LATIN SMALL LETTER K WITH HOOK"],
  ["ƚ", "019A", "LATIN SMALL LETTER L WITH BAR"],
  ["ƛ", "019B", "LATIN SMALL LETTER LAMBDA WITH STROKE"],
  ["Ɯ", "019C", "LATIN CAPITAL LETTER TURNED M"],
  ["Ɲ", "019D", "LATIN CAPITAL LETTER N WITH LEFT HOOK"],
  ["ƞ", "019E", "LATIN SMALL LETTER N WITH LONG RIGHT LEG"],
  ["Ɵ", "019F", "LATIN CAPITAL LETTER O WITH MIDDLE TILDE"],
  ["Ơ", "01A0", "LATIN CAPITAL LETTER O WITH HORN"],
  ["ơ", "01A1", "LATIN SMALL LETTER O WITH HORN"],
  ["Ƣ", "01A2", "LATIN CAPITAL LETTER OI"],
  ["ƣ", "01A3", "LATIN SMALL LETTER OI"],
  ["Ƥ", "01A4", "LATIN CAPITAL LETTER P WITH HOOK"],
  ["ƥ", "01A5", "LATIN SMALL LETTER P WITH HOOK"],
  ["Ʀ", "01A6", "LATIN LETTER YR"],
  ["Ƨ", "01A7", "LATIN CAPITAL LETTER TONE TWO"],
  ["ƨ", "01A8", "LATIN SMALL LETTER TONE TWO"],
  ["Ʃ", "01A9", "LATIN CAPITAL LETTER ESH"],
  ["ƪ", "01AA", "LATIN LETTER REVERSED ESH LOOP"],
  ["ƫ", "01AB", "LATIN SMALL LETTER T WITH PALATAL HOOK"],
  ["Ƭ", "01AC", "LATIN CAPITAL LETTER T WITH HOOK"],
  ["ƭ", "01AD", "LATIN SMALL LETTER T WITH HOOK"],
  ["Ʈ", "01AE", "LATIN CAPITAL LETTER T WITH RETROFLEX HOOK"],
  ["Ư", "01AF", "LATIN CAPITAL LETTER U WITH HORN"],
  ["ư", "01B0", "LATIN SMALL LETTER U WITH HORN"],
  ["Ʊ", "01B1", "LATIN CAPITAL LETTER UPSILON"],
  ["Ʋ", "01B2", "LATIN CAPITAL LETTER V WITH HOOK"],
  ["Ƴ", "01B3", "LATIN CAPITAL LETTER Y WITH HOOK"],
  ["ƴ", "01B4", "LATIN SMALL LETTER Y WITH HOOK"],
  ["Ƶ", "01B5", "LATIN CAPITAL LETTER Z WITH STROKE"],
  ["ƶ", "01B6", "LATIN SMALL LETTER Z WITH STROKE"],
  ["Ʒ", "01B7", "LATIN CAPITAL LETTER EZH"],
  ["Ƹ", "01B8", "LATIN CAPITAL LETTER EZH REVERSED"],
  ["ƹ", "01B9", "LATIN SMALL LETTER EZH REVERSED"],
  ["ƺ", "01BA", "LATIN SMALL LETTER EZH WITH TAIL"],
  ["ƻ", "01BB", "LATIN LETTER TWO WITH STROKE"],
  ["Ƽ", "01BC", "LATIN CAPITAL LETTER TONE FIVE"],
  ["ƽ", "01BD", "LATIN SMALL LETTER TONE FIVE"],
  ["ƾ", "01BE", "LATIN LETTER INVERTED GLOTTAL STOP WITH STROKE"],
  ["ƿ", "01BF", "LATIN LETTER WYNN"],
  ["ǀ", "01C0", "LATIN LETTER DENTAL CLICK"],
  ["ǁ", "01C1", "LATIN LETTER LATERAL CLICK"],
  ["ǂ", "01C2", "LATIN LETTER ALVEOLAR CLICK"],
  ["ǃ", "01C3", "LATIN LETTER RETROFLEX CLICK"],
  ["Ǆ", "01C4", "LATIN CAPITAL LETTER DZ WITH CARON"],
  ["ǅ", "01C5", "LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON"],
  ["ǆ", "01C6", "LATIN SMALL LETTER DZ WITH CARON"],
  ["Ǉ", "01C7", "LATIN CAPITAL LETTER LJ"],
  ["ǈ", "01C8", "LATIN CAPITAL LETTER L WITH SMALL LETTER J"],
  ["ǉ", "01C9", "LATIN SMALL LETTER LJ"],
  ["Ǌ", "01CA", "LATIN CAPITAL LETTER NJ"],
  ["ǋ", "01CB", "LATIN CAPITAL LETTER N WITH SMALL LETTER J"],
  ["ǌ", "01CC", "LATIN SMALL LETTER NJ"],
  ["Ǎ", "01CD", "LATIN CAPITAL LETTER A WITH CARON"],
  ["ǎ", "01CE", "LATIN SMALL LETTER A WITH CARON"],
  ["Ǐ", "01CF", "LATIN CAPITAL LETTER I WITH CARON"],
  ["ǐ", "01D0", "LATIN SMALL LETTER I WITH CARON"],

  ["Ǒ", "01D1", "LATIN CAPITAL LETTER O WITH CARON"],
  ["ǒ", "01D2", "LATIN SMALL LETTER O WITH CARON"],
  ["Ǔ", "01D3", "LATIN CAPITAL LETTER U WITH CARON"],
  ["ǔ", "01D4", "LATIN SMALL LETTER U WITH CARON"],
  ["Ǖ", "01D5", "LATIN CAPITAL LETTER U WITH DIAERESIS AND MACRON"],
  ["ǖ", "01D6", "LATIN SMALL LETTER U WITH DIAERESIS AND MACRON"],
  ["Ǘ", "01D7", "LATIN CAPITAL LETTER U WITH DIAERESIS AND ACUTE"],
  ["ǘ", "01D8", "LATIN SMALL LETTER U WITH DIAERESIS AND ACUTE"],
  ["Ǚ", "01D9", "LATIN CAPITAL LETTER U WITH DIAERESIS AND CARON"],
  ["ǚ", "01DA", "LATIN SMALL LETTER U WITH DIAERESIS AND CARON"],
  ["Ǜ", "01DB", "LATIN CAPITAL LETTER U WITH DIAERESIS AND GRAVE"],
  ["ǜ", "01DC", "LATIN SMALL LETTER U WITH DIAERESIS AND GRAVE"],
  ["ǝ", "01DD", "LATIN SMALL LETTER TURNED E"],
  ["Ǟ", "01DE", "LATIN CAPITAL LETTER A WITH DIAERESIS AND MACRON"],
  ["ǟ", "01DF", "LATIN SMALL LETTER A WITH DIAERESIS AND MACRON"],
  ["Ǡ", "01E0", "LATIN CAPITAL LETTER A WITH DOT ABOVE AND MACRON"],
  ["ǡ", "01E1", "LATIN SMALL LETTER A WITH DOT ABOVE AND MACRON"],
  ["Ǣ", "01E2", "LATIN CAPITAL LETTER AE WITH MACRON"],
  ["ǣ", "01E3", "LATIN SMALL LETTER AE WITH MACRON"],
  ["Ǥ", "01E4", "LATIN CAPITAL LETTER G WITH STROKE"],
  ["ǥ", "01E5", "LATIN SMALL LETTER G WITH STROKE"],
  ["Ǧ", "01E6", "LATIN CAPITAL LETTER G WITH CARON"],
  ["ǧ", "01E7", "LATIN SMALL LETTER G WITH CARON"],
  ["Ǩ", "01E8", "LATIN CAPITAL LETTER K WITH CARON"],
  ["ǩ", "01E9", "LATIN SMALL LETTER K WITH CARON"],
  ["Ǫ", "01EA", "LATIN CAPITAL LETTER O WITH OGONEK"],
  ["ǫ", "01EB", "LATIN SMALL LETTER O WITH OGONEK"],
  ["Ǭ", "01EC", "LATIN CAPITAL LETTER O WITH OGONEK AND MACRON"],
  ["ǭ", "01ED", "LATIN SMALL LETTER O WITH OGONEK AND MACRON"],
  ["Ǯ", "01EE", "LATIN CAPITAL LETTER EZH WITH CARON"],
  ["ǯ", "01EF", "LATIN SMALL LETTER EZH WITH CARON"],
  ["ǰ", "01F0", "LATIN SMALL LETTER J WITH CARON"],
  ["Ǳ", "01F1", "LATIN CAPITAL LETTER DZ"],
  ["ǲ", "01F2", "LATIN CAPITAL LETTER D WITH SMALL LETTER Z"],
  ["ǳ", "01F3", "LATIN SMALL LETTER DZ"],
  ["Ǵ", "01F4", "LATIN CAPITAL LETTER G WITH ACUTE"],
  ["ǵ", "01F5", "LATIN SMALL LETTER G WITH ACUTE"],
  ["Ƕ", "01F6", "LATIN CAPITAL LETTER HWAIR"],
  ["Ƿ", "01F7", "LATIN CAPITAL LETTER WYNN"],
  ["Ǹ", "01F8", "LATIN CAPITAL LETTER N WITH GRAVE"],
  ["ǹ", "01F9", "LATIN SMALL LETTER N WITH GRAVE"],
  ["Ǻ", "01FA", "LATIN CAPITAL LETTER A WITH RING ABOVE AND ACUTE"],
  ["ǻ", "01FB", "LATIN SMALL LETTER A WITH RING ABOVE AND ACUTE"],
  ["Ǽ", "01FC", "LATIN CAPITAL LETTER AE WITH ACUTE"],
  ["ǽ", "01FD", "LATIN SMALL LETTER AE WITH ACUTE"],
  ["Ǿ", "01FE", "LATIN CAPITAL LETTER O WITH STROKE AND ACUTE"],
  ["ǿ", "01FF", "LATIN SMALL LETTER O WITH STROKE AND ACUTE"],
  ["Ȁ", "0200", "LATIN CAPITAL LETTER A WITH DOUBLE GRAVE"],
  ["ȁ", "0201", "LATIN SMALL LETTER A WITH DOUBLE GRAVE"],
  ["Ȃ", "0202", "LATIN CAPITAL LETTER A WITH INVERTED BREVE"],
  ["ȃ", "0203", "LATIN SMALL LETTER A WITH INVERTED BREVE"],
  ["Ȅ", "0204", "LATIN CAPITAL LETTER E WITH DOUBLE GRAVE"],
  ["ȅ", "0205", "LATIN SMALL LETTER E WITH DOUBLE GRAVE"],
  ["Ȇ", "0206", "LATIN CAPITAL LETTER E WITH INVERTED BREVE"],
  ["ȇ", "0207", "LATIN SMALL LETTER E WITH INVERTED BREVE"],
  ["Ȉ", "0208", "LATIN CAPITAL LETTER I WITH DOUBLE GRAVE"],
  ["ȉ", "0209", "LATIN SMALL LETTER I WITH DOUBLE GRAVE"],
  ["Ȋ", "020A", "LATIN CAPITAL LETTER I WITH INVERTED BREVE"],
  ["ȋ", "020B", "LATIN SMALL LETTER I WITH INVERTED BREVE"],
  ["Ȍ", "020C", "LATIN CAPITAL LETTER O WITH DOUBLE GRAVE"],
  ["ȍ", "020D", "LATIN SMALL LETTER O WITH DOUBLE GRAVE"],
  ["Ȏ", "020E", "LATIN CAPITAL LETTER O WITH INVERTED BREVE"],
  ["ȏ", "020F", "LATIN SMALL LETTER O WITH INVERTED BREVE"],
  ["Ȑ", "0210", "LATIN CAPITAL LETTER R WITH DOUBLE GRAVE"],
  ["ȑ", "0211", "LATIN SMALL LETTER R WITH DOUBLE GRAVE"],
  ["Ȓ", "0212", "LATIN CAPITAL LETTER R WITH INVERTED BREVE"],
  ["ȓ", "0213", "LATIN SMALL LETTER R WITH INVERTED BREVE"],

  ["Ȕ", "0214", "LATIN CAPITAL LETTER U WITH DOUBLE GRAVE"],
  ["ȕ", "0215", "LATIN SMALL LETTER U WITH DOUBLE GRAVE"],
  ["Ȗ", "0216", "LATIN CAPITAL LETTER U WITH INVERTED BREVE"],
  ["ȗ", "0217", "LATIN SMALL LETTER U WITH INVERTED BREVE"],
  ["Ș", "0218", "LATIN CAPITAL LETTER S WITH COMMA BELOW"],
  ["ș", "0219", "LATIN SMALL LETTER S WITH COMMA BELOW"],
  ["Ț", "021A", "LATIN CAPITAL LETTER T WITH COMMA BELOW"],
  ["ț", "021B", "LATIN SMALL LETTER T WITH COMMA BELOW"],
  ["Ȝ", "021C", "LATIN CAPITAL LETTER YOGH"],
  ["ȝ", "021D", "LATIN SMALL LETTER YOGH"],
  ["Ȟ", "021E", "LATIN CAPITAL LETTER H WITH CARON"],
  ["ȟ", "021F", "LATIN SMALL LETTER H WITH CARON"],
  ["Ƞ", "0220", "LATIN CAPITAL LETTER N WITH LONG RIGHT LEG"],
  ["ȡ", "0221", "LATIN SMALL LETTER D WITH CURL"],
  ["Ȣ", "0222", "LATIN CAPITAL LETTER OU"],
  ["ȣ", "0223", "LATIN SMALL LETTER OU"],
  ["Ȥ", "0224", "LATIN CAPITAL LETTER Z WITH HOOK"],
  ["ȥ", "0225", "LATIN SMALL LETTER Z WITH HOOK"],
  ["Ȧ", "0226", "LATIN CAPITAL LETTER A WITH DOT ABOVE"],
  ["ȧ", "0227", "LATIN SMALL LETTER A WITH DOT ABOVE"],
  ["Ȩ", "0228", "LATIN CAPITAL LETTER E WITH CEDILLA"],
  ["ȩ", "0229", "LATIN SMALL LETTER E WITH CEDILLA"],
  ["Ȫ", "022A", "LATIN CAPITAL LETTER O WITH DIAERESIS AND MACRON"],
  ["ȫ", "022B", "LATIN SMALL LETTER O WITH DIAERESIS AND MACRON"],
  ["Ȭ", "022C", "LATIN CAPITAL LETTER O WITH TILDE AND MACRON"],
  ["ȭ", "022D", "LATIN SMALL LETTER O WITH TILDE AND MACRON"],
  ["Ȯ", "022E", "LATIN CAPITAL LETTER O WITH DOT ABOVE"],
  ["ȯ", "022F", "LATIN SMALL LETTER O WITH DOT ABOVE"],
  ["Ȱ", "0230", "LATIN CAPITAL LETTER O WITH DOT ABOVE AND MACRON"],
  ["ȱ", "0231", "LATIN SMALL LETTER O WITH DOT ABOVE AND MACRON"],
  ["Ȳ", "0232", "LATIN CAPITAL LETTER Y WITH MACRON"],
  ["ȳ", "0233", "LATIN SMALL LETTER Y WITH MACRON"],
  ["ȴ", "0234", "LATIN SMALL LETTER L WITH CURL"],
  ["ȵ", "0235", "LATIN SMALL LETTER N WITH CURL"],
  ["ȶ", "0236", "LATIN SMALL LETTER T WITH CURL"],
  ["ȷ", "0237", "LATIN SMALL LETTER DOTLESS J"],
  ["ȸ", "0238", "LATIN SMALL LETTER DB DIGRAPH"],
  ["ȹ", "0239", "LATIN SMALL LETTER QP DIGRAPH"],
  ["Ⱥ", "023A", "LATIN CAPITAL LETTER A WITH STROKE"],
  ["Ȼ", "023B", "LATIN CAPITAL LETTER C WITH STROKE"],
  ["ȼ", "023C", "LATIN SMALL LETTER C WITH STROKE"],
  ["Ƚ", "023D", "LATIN CAPITAL LETTER L WITH BAR"],
  ["Ⱦ", "023E", "LATIN CAPITAL LETTER T WITH DIAGONAL STROKE"],
  ["ȿ", "023F", "LATIN SMALL LETTER S WITH SWASH TAIL"],
  ["ɀ", "0240", "LATIN SMALL LETTER Z WITH SWASH TAIL"],
  ["Ɂ", "0241", "LATIN CAPITAL LETTER GLOTTAL STOP"],
  ["ɂ", "0242", "LATIN SMALL LETTER GLOTTAL STOP"],
  ["Ƀ", "0243", "LATIN CAPITAL LETTER B WITH STROKE"],
  ["Ʉ", "0244", "LATIN CAPITAL LETTER U BAR"],
  ["Ʌ", "0245", "LATIN CAPITAL LETTER TURNED V"],
  ["Ɇ", "0246", "LATIN CAPITAL LETTER E WITH STROKE"],
  ["ɇ", "0247", "LATIN SMALL LETTER E WITH STROKE"],
  ["Ɉ", "0248", "LATIN CAPITAL LETTER J WITH STROKE"],
  ["ɉ", "0249", "LATIN SMALL LETTER J WITH STROKE"],
  ["Ɋ", "024A", "LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL"],
  ["ɋ", "024B", "LATIN SMALL LETTER Q WITH HOOK TAIL"],
  ["Ɍ", "024C", "LATIN CAPITAL LETTER R WITH STROKE"],
  ["ɍ", "024D", "LATIN SMALL LETTER R WITH STROKE"],
  ["Ɏ", "024E", "LATIN CAPITAL LETTER Y WITH STROKE"],
  ["ɏ", "024F", "LATIN SMALL LETTER Y WITH STROKE"],
  ["ʰ", "02B0", "MODIFIER LETTER SMALL H"],
  ["ʱ", "02B1", "MODIFIER LETTER SMALL H WITH HOOK"],
  ["ʲ", "02B2", "MODIFIER LETTER SMALL J"],
  ["ʳ", "02B3", "MODIFIER LETTER SMALL R"],
  ["ʴ", "02B4", "MODIFIER LETTER SMALL TURNED R"],
  ["ʵ", "02B5", "MODIFIER LETTER SMALL TURNED R WITH HOOK"],
  ["ʶ", "02B6", "MODIFIER LETTER SMALL CAPITAL INVERTED R"],
  ["ʷ", "02B7", "MODIFIER LETTER SMALL W"],
  ["ʸ", "02B8", "MODIFIER LETTER SMALL Y"],
  ["ʹ", "02B9", "MODIFIER LETTER PRIME"],
  ["ʺ", "02BA", "MODIFIER LETTER DOUBLE PRIME"],
  ["ʻ", "02BB", "MODIFIER LETTER TURNED COMMA"],
  ["ʼ", "02BC", "MODIFIER LETTER APOSTROPHE"],
  ["ʽ", "02BD", "MODIFIER LETTER REVERSED COMMA"],
  ["ʾ", "02BE", "MODIFIER LETTER RIGHT HALF RING"],
  ["ʿ", "02BF", "MODIFIER LETTER LEFT HALF RING"],
  ["ˀ", "02C0", "MODIFIER LETTER GLOTTAL STOP"],
  ["ˁ", "02C1", "MODIFIER LETTER REVERSED GLOTTAL STOP"],
  ["˂", "02C2", "MODIFIER LETTER LEFT ARROWHEAD"],
  ["˃", "02C3", "MODIFIER LETTER RIGHT ARROWHEAD"],
  ["˄", "02C4", "MODIFIER LETTER UP ARROWHEAD"],
  ["˅", "02C5", "MODIFIER LETTER DOWN ARROWHEAD"],
  ["ˆ", "02C6", "MODIFIER LETTER CIRCUMFLEX ACCENT"],
  ["ˇ", "02C7", "CARON"],
  ["ˈ", "02C8", "MODIFIER LETTER VERTICAL LINE"],
  ["ˉ", "02C9", "MODIFIER LETTER MACRON"],
  ["ˊ", "02CA", "MODIFIER LETTER ACUTE ACCENT"],
  ["ˋ", "02CB", "MODIFIER LETTER GRAVE ACCENT"],
  ["ˌ", "02CC", "MODIFIER LETTER LOW VERTICAL LINE"],
  ["ˍ", "02CD", "MODIFIER LETTER LOW MACRON"],
  ["ˎ", "02CE", "MODIFIER LETTER LOW GRAVE ACCENT"],
  ["ˏ", "02CF", "MODIFIER LETTER LOW ACUTE ACCENT"],
  ["ː", "02D0", "MODIFIER LETTER TRIANGULAR COLON"],
  ["ˑ", "02D1", "MODIFIER LETTER HALF TRIANGULAR COLON"],
  ["˒", "02D2", "MODIFIER LETTER CENTRED RIGHT HALF RING"],
  ["˓", "02D3", "MODIFIER LETTER CENTRED LEFT HALF RING"],
  ["˔", "02D4", "MODIFIER LETTER UP TACK"],
  ["˕", "02D5", "MODIFIER LETTER DOWN TACK"],
  ["˖", "02D6", "MODIFIER LETTER PLUS SIGN"],
  ["˗", "02D7", "MODIFIER LETTER MINUS SIGN"],
  ["˘", "02D8", "BREVE"],
  ["˙", "02D9", "DOT ABOVE"],
  ["˚", "02DA", "RING ABOVE"],
  ["˛", "02DB", "OGONEK"],
  ["˜", "02DC", "SMALL TILDE"],
  ["˝", "02DD", "DOUBLE ACUTE ACCENT"],
  ["˞", "02DE", "MODIFIER LETTER RHOTIC HOOK"],
  ["˟", "02DF", "MODIFIER LETTER CROSS ACCENT"],
  ["ˠ", "02E0", "MODIFIER LETTER SMALL GAMMA"],
  ["ˡ", "02E1", "MODIFIER LETTER SMALL L"],
  ["ˢ", "02E2", "MODIFIER LETTER SMALL S"],
  ["ˣ", "02E3", "MODIFIER LETTER SMALL X"],
  ["ˤ", "02E4", "MODIFIER LETTER SMALL REVERSED GLOTTAL STOP"],
  ["˥", "02E5", "MODIFIER LETTER EXTRA-HIGH TONE BAR"],
  ["˦", "02E6", "MODIFIER LETTER HIGH TONE BAR"],
  ["˧", "02E7", "MODIFIER LETTER MID TONE BAR"],
  ["˨", "02E8", "MODIFIER LETTER LOW TONE BAR"],
  ["˩", "02E9", "MODIFIER LETTER EXTRA-LOW TONE BAR"],
  ["˪", "02EA", "MODIFIER LETTER YIN DEPARTING TONE MARK"],
  ["˫", "02EB", "MODIFIER LETTER YANG DEPARTING TONE MARK"],
  ["ˬ", "02EC", "MODIFIER LETTER VOICING"],
  ["˭", "02ED", "MODIFIER LETTER UNASPIRATED"],
  ["ˮ", "02EE", "MODIFIER LETTER DOUBLE APOSTROPHE"],
  ["˯", "02EF", "MODIFIER LETTER LOW DOWN ARROWHEAD"],
  ["˰", "02F0", "MODIFIER LETTER LOW UP ARROWHEAD"],
  ["˱", "02F1", "MODIFIER LETTER LOW LEFT ARROWHEAD"],
  ["˲", "02F2", "MODIFIER LETTER LOW RIGHT ARROWHEAD"],
  ["˳", "02F3", "MODIFIER LETTER LOW RING"],
  ["˴", "02F4", "MODIFIER LETTER MIDDLE GRAVE ACCENT"],
  ["˵", "02F5", "MODIFIER LETTER MIDDLE DOUBLE GRAVE ACCENT"],
  ["˶", "02F6", "MODIFIER LETTER MIDDLE DOUBLE ACUTE ACCENT"],
  ["˷", "02F7", "MODIFIER LETTER LOW TILDE"],
  ["˸", "02F8", "MODIFIER LETTER RAISED COLON"],
  ["˹", "02F9", "MODIFIER LETTER BEGIN HIGH TONE"],
  ["˺", "02FA", "MODIFIER LETTER END HIGH TONE"],
  ["˻", "02FB", "MODIFIER LETTER BEGIN LOW TONE"],
  ["˼", "02FC", "MODIFIER LETTER END LOW TONE"],
  ["˽", "02FD", "MODIFIER LETTER SHELF"],
  ["˾", "02FE", "MODIFIER LETTER OPEN SHELF"],
  ["˿", "02FF", "MODIFIER LETTER LOW LEFT ARROW"],

  ["˿", "02FF", "MODIFIER LETTER LOW LEFT ARROW"],

  // New section (combining marks, diacritics, etc.)
  ["ò", "0300", "GRAVE ACCENT"],
  ["ó", "0301", "ACUTE ACCENT"],
  ["ô", "0302", "CIRCUMFLEX ACCENT"],
  ["õ", "0303", "TILDE"],
  ["ō", "0304", "MACRON"],
  ["o̅", "0305", "OVERLINE"],
  ["ŏ", "0306", "BREVE"],
  ["ȯ", "0307", "DOT ABOVE"],
  ["ö", "0308", "DIAERESIS"],
  ["ỏ", "0309", "HOOK ABOVE"],
  ["o̊", "030A", "RING ABOVE"],
  ["ő", "030B", "DOUBLE ACUTE ACCENT"],
  ["ǒ", "030C", "CARON"],
  ["o̍", "030D", "VERTICAL LINE ABOVE"],
  ["o̎", "030E", "DOUBLE VERTICAL LINE ABOVE"],
  ["ȍ", "030F", "DOUBLE GRAVE ACCENT"],
  ["o̐", "0310", "CANDRABINDU"],
  ["ȏ", "0311", "INVERTED BREVE"],
  ["o̒", "0312", "TURNED COMMA ABOVE"],
  ["o̓", "0313", "COMMA ABOVE"],
  ["o̔", "0314", "REVERSED COMMA ABOVE"],
  ["o̕", "0315", "COMMA ABOVE RIGHT"],
  ["o̖", "0316", "GRAVE ACCENT BELOW"],
  ["o̗", "0317", "ACUTE ACCENT BELOW"],
  ["o̘", "0318", "LEFT TACK BELOW"],
  ["o̙", "0319", "RIGHT TACK BELOW"],
  ["o̚", "031A", "LEFT ANGLE ABOVE"],
  ["ơ", "031B", "HORN"],
  ["o̜", "031C", "LEFT HALF RING BELOW"],
  ["o̝", "031D", "UP TACK BELOW"],
  ["o̞", "031E", "DOWN TACK BELOW"],
  ["o̟", "031F", "PLUS SIGN BELOW"],
  ["o̠", "0320", "MINUS SIGN BELOW"],
  ["o̡", "0321", "PALATALIZED HOOK BELOW"],
  ["o̢", "0322", "RETROFLEX HOOK BELOW"],
  ["ọ", "0323", "DOT BELOW"],
  ["o̤", "0324", "DIAERESIS BELOW"],
  ["o̥", "0325", "RING BELOW"],
  ["o̦", "0326", "COMMA BELOW"],
  ["o̧", "0327", "CEDILLA"],
  ["ǫ", "0328", "OGONEK"],
  ["o̩", "0329", "VERTICAL LINE BELOW"],
  ["o̪", "032A", "BRIDGE BELOW"],
  ["o̫", "032B", "INVERTED DOUBLE ARCH BELOW"],
  ["o̬", "032C", "CARON BELOW"],
  ["o̭", "032D", "CIRCUMFLEX ACCENT BELOW"],
  ["o̮", "032E", "BREVE BELOW"],
  ["o̯", "032F", "INVERTED BREVE BELOW"],
  ["o̰", "0330", "TILDE BELOW"],
  ["o̱", "0331", "MACRON BELOW"],
  ["o̲", "0332", "LOW LINE"],
  ["o̳", "0333", "DOUBLE LOW LINE"],
  ["o̴", "0334", "TILDE OVERLAY"],
  ["o̵", "0335", "SHORT STROKE OVERLAY"],
  ["o̶", "0336", "LONG STROKE OVERLAY"],
  ["o̷", "0337", "SHORT SOLIDUS OVERLAY"],
  ["o̸", "0338", "LONG SOLIDUS OVERLAY"],
  ["o̹", "0339", "RIGHT HALF RING BELOW"],
  ["o̺", "033A", "INVERTED BRIDGE BELOW"],
  ["o̻", "033B", "SQUARE BELOW"],
  ["o̼", "033C", "SEAGULL BELOW"],
  ["o̽", "033D", "X ABOVE"],
  ["o̾", "033E", "VERTICAL TILDE"],
  ["o̿", "033F", "DOUBLE OVERLINE"],
  ["ò", "0340", "GRAVE TONE MARK"],
  ["ó", "0341", "ACUTE TONE MARK"],
  ["o͂", "0342", "GREEK PERISPOMENI (combined with theta)"],
  ["o̓", "0343", "GREEK KORONIS (combined with theta)"],
  ["ö́", "0344", "GREEK DIALYTIKA TONOS (combined with theta)"],
  ["oͅ", "0345", "GREEK YPOGEGRAMMENI (combined with theta)"],
  ["o͆", "0346", "BRIDGE ABOVE"],
  ["o͇", "0347", "EQUALS SIGN BELOW"],
  ["o͈", "0348", "DOUBLE VERTICAL LINE BELOW"],
  ["o͉", "0349", "LEFT ANGLE BELOW"],
  ["o͊", "034A", "NOT TILDE ABOVE"],
  ["o͋", "034B", "HOMOTHETIC ABOVE"],
  ["o͌", "034C", "ALMOST EQUAL TO ABOVE"],
  ["o͍", "034D", "LEFT RIGHT ARROW BELOW"],
  ["o͎", "034E", "UPWARDS ARROW BELOW"],
  ["o͏", "034F", "GRAPHEME JOINER"],
  ["o͐", "0350", "RIGHT ARROWHEAD ABOVE"],
  ["o͑", "0351", "LEFT HALF RING ABOVE"],
  ["o͒", "0352", "FERMATA"],
  ["o͓", "0353", "X BELOW"],
  ["o͔", "0354", "LEFT ARROWHEAD BELOW"],
  ["o͕", "0355", "RIGHT ARROWHEAD BELOW"],
  ["o͖", "0356", "RIGHT ARROWHEAD AND UP ARROWHEAD BELOW"],
  ["o͗", "0357", "RIGHT HALF RING ABOVE"],
  ["o͘", "0358", "DOT ABOVE RIGHT"],
  ["o͙", "0359", "ASTERISK BELOW"],
  ["o͚", "035A", "DOUBLE RING BELOW"],
  ["o͛", "035B", "ZIGZAG ABOVE"],
  ["͜o", "035C", "DOUBLE BREVE BELOW"],
  ["͝o", "035D", "DOUBLE BREVE"],
  ["͞o", "035E", "DOUBLE MACRON"],
  ["͟o", "035F", "DOUBLE MACRON BELOW"],
  ["͠o", "0360", "DOUBLE TILDE"],
  ["͡o", "0361", "DOUBLE INVERTED BREVE"],
  ["͢o", "0362", "DOUBLE RIGHTWARDS ARROW BELOW"],
  ["oͣ", "0363", "LATIN SMALL LETTER A"],
  ["oͤ", "0364", "LATIN SMALL LETTER E"],
  ["oͥ", "0365", "LATIN SMALL LETTER I"],
  ["oͦ", "0366", "LATIN SMALL LETTER O"],
  ["oͧ", "0367", "LATIN SMALL LETTER U"],
  ["oͨ", "0368", "LATIN SMALL LETTER C"],
  ["oͩ", "0369", "LATIN SMALL LETTER D"],
  ["oͪ", "036A", "LATIN SMALL LETTER H"],
  ["oͫ", "036B", "LATIN SMALL LETTER M"],
  ["oͬ", "036C", "LATIN SMALL LETTER R"],
  ["oͭ", "036D", "LATIN SMALL LETTER T"],
  ["oͮ", "036E", "LATIN SMALL LETTER V"],
  ["oͯ", "036F", "LATIN SMALL LETTER X"],
  ["Ͱ", "0370", "GREEK CAPITAL LETTER HETA"],
  ["ͱ", "0371", "GREEK SMALL LETTER HETA"],
  ["Ͳ", "0372", "GREEK CAPITAL LETTER ARCHAIC SAMPI"],
  ["ͳ", "0373", "GREEK SMALL LETTER ARCHAIC SAMPI"],

  ["ʹ", "0374", "GREEK NUMERAL SIGN"],
  ["͵", "0375", "GREEK LOWER NUMERAL SIGN"],
  ["Ͷ", "0376", "GREEK CAPITAL LETTER PAMPHYLIAN DIGAMMA"],
  ["ͷ", "0377", "GREEK SMALL LETTER PAMPHYLIAN DIGAMMA"],
  ["ͺ", "037A", "GREEK YPOGEGRAMMENI"],
  ["ͻ", "037B", "GREEK SMALL REVERSED LUNATE SIGMA SYMBOL"],
  ["ͼ", "037C", "GREEK SMALL DOTTED LUNATE SIGMA SYMBOL"],
  ["ͽ", "037D", "GREEK SMALL REVERSED DOTTED LUNATE SIGMA SYMBOL"],
  [";", "037E", "GREEK QUESTION MARK"],
  ["΄", "0384", "GREEK TONOS"],
  ["΅", "0385", "GREEK DIALYTIKA TONOS"],
  ["Ά", "0386", "GREEK CAPITAL LETTER ALPHA WITH TONOS"],
  ["·", "0387", "GREEK ANO TELEIA"],
  ["Έ", "0388", "GREEK CAPITAL LETTER EPSILON WITH TONOS"],
  ["Ή", "0389", "GREEK CAPITAL LETTER ETA WITH TONOS"],
  ["Ί", "038A", "GREEK CAPITAL LETTER IOTA WITH TONOS"],
  ["Ό", "038C", "GREEK CAPITAL LETTER OMICRON WITH TONOS"],
  ["Ύ", "038E", "GREEK CAPITAL LETTER UPSILON WITH TONOS"],
  ["Ώ", "038F", "GREEK CAPITAL LETTER OMEGA WITH TONOS"],
  ["ΐ", "0390", "GREEK SMALL LETTER IOTA WITH DIALYTIKA AND TONOS"],
  ["Α", "0391", "GREEK CAPITAL LETTER ALPHA"],
  ["Β", "0392", "GREEK CAPITAL LETTER BETA"],
  ["Γ", "0393", "GREEK CAPITAL LETTER GAMMA"],
  ["Δ", "0394", "GREEK CAPITAL LETTER DELTA"],
  ["Ε", "0395", "GREEK CAPITAL LETTER EPSILON"],
  ["Ζ", "0396", "GREEK CAPITAL LETTER ZETA"],
  ["Η", "0397", "GREEK CAPITAL LETTER ETA"],
  ["Θ", "0398", "GREEK CAPITAL LETTER THETA"],
  ["Ι", "0399", "GREEK CAPITAL LETTER IOTA"],
  ["Κ", "039A", "GREEK CAPITAL LETTER KAPPA"],
  ["Λ", "039B", "GREEK CAPITAL LETTER LAMBDA"],
  ["Μ", "039C", "GREEK CAPITAL LETTER MU"],
  ["Ν", "039D", "GREEK CAPITAL LETTER NU"],
  ["Ξ", "039E", "GREEK CAPITAL LETTER XI"],
  ["Ο", "039F", "GREEK CAPITAL LETTER OMICRON"],
  ["Π", "03A0", "GREEK CAPITAL LETTER PI"],
  ["Ρ", "03A1", "GREEK CAPITAL LETTER RHO"],
  ["Σ", "03A3", "GREEK CAPITAL LETTER SIGMA"],
  ["Τ", "03A4", "GREEK CAPITAL LETTER TAU"],
  ["Υ", "03A5", "GREEK CAPITAL LETTER UPSILON"],
  ["Φ", "03A6", "GREEK CAPITAL LETTER PHI"],
  ["Χ", "03A7", "GREEK CAPITAL LETTER CHI"],
  ["Ψ", "03A8", "GREEK CAPITAL LETTER PSI"],
  ["Ω", "03A9", "GREEK CAPITAL LETTER OMEGA"],
  ["Ϊ", "03AA", "GREEK CAPITAL LETTER IOTA WITH DIALYTIKA"],
  ["Ϋ", "03AB", "GREEK CAPITAL LETTER UPSILON WITH DIALYTIKA"],
  ["ά", "03AC", "GREEK SMALL LETTER ALPHA WITH TONOS"],
  ["έ", "03AD", "GREEK SMALL LETTER EPSILON WITH TONOS"],
  ["ή", "03AE", "GREEK SMALL LETTER ETA WITH TONOS"],
  ["ί", "03AF", "GREEK SMALL LETTER IOTA WITH TONOS"],
  ["ΰ", "03B0", "GREEK SMALL LETTER UPSILON WITH DIALYTIKA AND TONOS"],
  ["α", "03B1", "GREEK SMALL LETTER ALPHA"],
  ["β", "03B2", "GREEK SMALL LETTER BETA"],
  ["γ", "03B3", "GREEK SMALL LETTER GAMMA"],
  ["δ", "03B4", "GREEK SMALL LETTER DELTA"],
  ["ε", "03B5", "GREEK SMALL LETTER EPSILON"],
  ["ζ", "03B6", "GREEK SMALL LETTER ZETA"],
  ["η", "03B7", "GREEK SMALL LETTER ETA"],
  ["θ", "03B8", "GREEK SMALL LETTER THETA"],
  ["ι", "03B9", "GREEK SMALL LETTER IOTA"],
  ["κ", "03BA", "GREEK SMALL LETTER KAPPA"],
  ["λ", "03BB", "GREEK SMALL LETTER LAMBDA"],
  ["μ", "03BC", "GREEK SMALL LETTER MU"],
  ["ν", "03BD", "GREEK SMALL LETTER NU"],
  ["ξ", "03BE", "GREEK SMALL LETTER XI"],
  ["ο", "03BF", "GREEK SMALL LETTER OMICRON"],
  ["π", "03C0", "GREEK SMALL LETTER PI"],
  ["ρ", "03C1", "GREEK SMALL LETTER RHO"],
  ["ς", "03C2", "GREEK SMALL LETTER FINAL SIGMA"],
  ["σ", "03C3", "GREEK SMALL LETTER SIGMA"],
  ["τ", "03C4", "GREEK SMALL LETTER TAU"],
  ["υ", "03C5", "GREEK SMALL LETTER UPSILON"],
  ["φ", "03C6", "GREEK SMALL LETTER PHI"],
  ["χ", "03C7", "GREEK SMALL LETTER CHI"],
  ["ψ", "03C8", "GREEK SMALL LETTER PSI"],
  ["ω", "03C9", "GREEK SMALL LETTER OMEGA"],
  ["ϊ", "03CA", "GREEK SMALL LETTER IOTA WITH DIALYTIKA"],
  ["ϋ", "03CB", "GREEK SMALL LETTER UPSILON WITH DIALYTIKA"],
  ["ό", "03CC", "GREEK SMALL LETTER OMICRON WITH TONOS"],
  ["ύ", "03CD", "GREEK SMALL LETTER UPSILON WITH TONOS"],
  ["ώ", "03CE", "GREEK SMALL LETTER OMEGA WITH TONOS"],
  ["Ϗ", "03CF", "GREEK CAPITAL KAI SYMBOL"],
  ["ϐ", "03D0", "GREEK BETA SYMBOL"],
  ["ϑ", "03D1", "GREEK THETA SYMBOL"],
  ["ϒ", "03D2", "GREEK UPSILON WITH HOOK SYMBOL"],
  ["ϓ", "03D3", "GREEK UPSILON WITH ACUTE AND HOOK SYMBOL"],
  ["ϔ", "03D4", "GREEK UPSILON WITH DIAERESIS AND HOOK SYMBOL"],
  ["ϕ", "03D5", "GREEK PHI SYMBOL"],
  ["ϖ", "03D6", "GREEK PI SYMBOL"],
  ["ϗ", "03D7", "GREEK KAI SYMBOL"],
  ["Ϙ", "03D8", "GREEK LETTER ARCHAIC KOPPA"],
  ["ϙ", "03D9", "GREEK SMALL LETTER ARCHAIC KOPPA"],
  ["Ϛ", "03DA", "GREEK LETTER STIGMA"],
  ["ϛ", "03DB", "GREEK SMALL LETTER STIGMA"],
  ["Ϝ", "03DC", "GREEK LETTER DIGAMMA"],
  ["ϝ", "03DD", "GREEK SMALL LETTER DIGAMMA"],
  ["Ϟ", "03DE", "GREEK LETTER KOPPA"],
  ["ϟ", "03DF", "GREEK SMALL LETTER KOPPA"],
  ["Ϡ", "03E0", "GREEK LETTER SAMPI"],
  ["ϡ", "03E1", "GREEK SMALL LETTER SAMPI"],
  ["Ϣ", "03E2", "COPTIC CAPITAL LETTER SHEI"],
  ["ϣ", "03E3", "COPTIC SMALL LETTER SHEI"],
  ["Ϥ", "03E4", "COPTIC CAPITAL LETTER FEI"],
  ["ϥ", "03E5", "COPTIC SMALL LETTER FEI"],
  ["Ϧ", "03E6", "COPTIC CAPITAL LETTER KHEI"],
  ["ϧ", "03E7", "COPTIC SMALL LETTER KHEI"],
  ["Ϩ", "03E8", "COPTIC CAPITAL LETTER HORI"],
  ["ϩ", "03E9", "COPTIC SMALL LETTER HORI"],
  ["Ϫ", "03EA", "COPTIC CAPITAL LETTER GANGIA"],
  ["ϫ", "03EB", "COPTIC SMALL LETTER GANGIA"],
  ["Ϭ", "03EC", "COPTIC CAPITAL LETTER SHIMA"],
  ["ϭ", "03ED", "COPTIC SMALL LETTER SHIMA"],
  ["Ϯ", "03EE", "COPTIC CAPITAL LETTER DEI"],
  ["ϯ", "03EF", "COPTIC SMALL LETTER DEI"],
  ["ϰ", "03F0", "GREEK KAPPA SYMBOL"],
  ["ϱ", "03F1", "GREEK RHO SYMBOL"],
  ["ϲ", "03F2", "GREEK LUNATE SIGMA SYMBOL"],
  ["ϳ", "03F3", "GREEK LETTER YOT"],
  ["ϴ", "03F4", "GREEK CAPITAL THETA SYMBOL"],
  ["ϵ", "03F5", "GREEK LUNATE EPSILON SYMBOL"],
  ["϶", "03F6", "GREEK REVERSED LUNATE EPSILON SYMBOL"],
  ["Ϸ", "03F7", "GREEK CAPITAL LETTER SHO"],
  ["ϸ", "03F8", "GREEK SMALL LETTER SHO"],
  ["Ϲ", "03F9", "GREEK CAPITAL LUNATE SIGMA SYMBOL"],
  ["Ϻ", "03FA", "GREEK CAPITAL LETTER SAN"],
  ["ϻ", "03FB", "GREEK SMALL LETTER SAN"],
  ["ϼ", "03FC", "GREEK RHO WITH STROKE SYMBOL"],
  ["Ͻ", "03FD", "GREEK CAPITAL REVERSED LUNATE SIGMA SYMBOL"],
  ["Ͼ", "03FE", "GREEK CAPITAL DOTTED LUNATE SIGMA SYMBOL"],
  ["Ͽ", "03FF", "GREEK CAPITAL REVERSED DOTTED LUNATE SIGMA SYMBOL"],
  ["Ѐ", "0400", "CYRILLIC CAPITAL LETTER IE WITH GRAVE"],
  ["Ё", "0401", "CYRILLIC CAPITAL LETTER IO"],
  ["Ђ", "0402", "CYRILLIC CAPITAL LETTER DJE"],
  ["Ѓ", "0403", "CYRILLIC CAPITAL LETTER GJE"],
  ["Є", "0404", "CYRILLIC CAPITAL LETTER UKRAINIAN IE"],
  ["Ѕ", "0405", "CYRILLIC CAPITAL LETTER DZE"],
  ["І", "0406", "CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"],
  ["Ї", "0407", "CYRILLIC CAPITAL LETTER YI"],

  ["Ј", "0408", "CYRILLIC CAPITAL LETTER JE"],
  ["Љ", "0409", "CYRILLIC CAPITAL LETTER LJE"],
  ["Њ", "040A", "CYRILLIC CAPITAL LETTER NJE"],
  ["Ћ", "040B", "CYRILLIC CAPITAL LETTER TSHE"],
  ["Ќ", "040C", "CYRILLIC CAPITAL LETTER KJE"],
  ["Ѝ", "040D", "CYRILLIC CAPITAL LETTER I WITH GRAVE"],
  ["Ў", "040E", "CYRILLIC CAPITAL LETTER SHORT U"],
  ["Џ", "040F", "CYRILLIC CAPITAL LETTER DZHE"],
  ["А", "0410", "CYRILLIC CAPITAL LETTER A"],
  ["Б", "0411", "CYRILLIC CAPITAL LETTER BE"],
  ["В", "0412", "CYRILLIC CAPITAL LETTER VE"],
  ["Г", "0413", "CYRILLIC CAPITAL LETTER GHE"],
  ["Д", "0414", "CYRILLIC CAPITAL LETTER DE"],
  ["Е", "0415", "CYRILLIC CAPITAL LETTER IE"],
  ["Ж", "0416", "CYRILLIC CAPITAL LETTER ZHE"],
  ["З", "0417", "CYRILLIC CAPITAL LETTER ZE"],
  ["И", "0418", "CYRILLIC CAPITAL LETTER I"],
  ["Й", "0419", "CYRILLIC CAPITAL LETTER SHORT I"],
  ["К", "041A", "CYRILLIC CAPITAL LETTER KA"],
  ["Л", "041B", "CYRILLIC CAPITAL LETTER EL"],
  ["М", "041C", "CYRILLIC CAPITAL LETTER EM"],
  ["Н", "041D", "CYRILLIC CAPITAL LETTER EN"],
  ["О", "041E", "CYRILLIC CAPITAL LETTER O"],
  ["П", "041F", "CYRILLIC CAPITAL LETTER PE"],
  ["Р", "0420", "CYRILLIC CAPITAL LETTER ER"],
  ["С", "0421", "CYRILLIC CAPITAL LETTER ES"],
  ["Т", "0422", "CYRILLIC CAPITAL LETTER TE"],
  ["У", "0423", "CYRILLIC CAPITAL LETTER U"],
  ["Ф", "0424", "CYRILLIC CAPITAL LETTER EF"],
  ["Х", "0425", "CYRILLIC CAPITAL LETTER HA"],
  ["Ц", "0426", "CYRILLIC CAPITAL LETTER TSE"],
  ["Ч", "0427", "CYRILLIC CAPITAL LETTER CHE"],
  ["Ш", "0428", "CYRILLIC CAPITAL LETTER SHA"],
  ["Щ", "0429", "CYRILLIC CAPITAL LETTER SHCHA"],
  ["Ъ", "042A", "CYRILLIC CAPITAL LETTER HARD SIGN"],
  ["Ы", "042B", "CYRILLIC CAPITAL LETTER YERU"],
  ["Ь", "042C", "CYRILLIC CAPITAL LETTER SOFT SIGN"],
  ["Э", "042D", "CYRILLIC CAPITAL LETTER E"],
  ["Ю", "042E", "CYRILLIC CAPITAL LETTER YU"],
  ["Я", "042F", "CYRILLIC CAPITAL LETTER YA"],
  ["а", "0430", "CYRILLIC SMALL LETTER A"],
  ["б", "0431", "CYRILLIC SMALL LETTER BE"],
  ["в", "0432", "CYRILLIC SMALL LETTER VE"],
  ["г", "0433", "CYRILLIC SMALL LETTER GHE"],
  ["д", "0434", "CYRILLIC SMALL LETTER DE"],
  ["е", "0435", "CYRILLIC SMALL LETTER IE"],
  ["ж", "0436", "CYRILLIC SMALL LETTER ZHE"],
  ["з", "0437", "CYRILLIC SMALL LETTER ZE"],
  ["и", "0438", "CYRILLIC SMALL LETTER I"],
  ["й", "0439", "CYRILLIC SMALL LETTER SHORT I"],
  ["к", "043A", "CYRILLIC SMALL LETTER KA"],
  ["л", "043B", "CYRILLIC SMALL LETTER EL"],
  ["м", "043C", "CYRILLIC SMALL LETTER EM"],
  ["н", "043D", "CYRILLIC SMALL LETTER EN"],
  ["о", "043E", "CYRILLIC SMALL LETTER O"],
  ["п", "043F", "CYRILLIC SMALL LETTER PE"],
  ["р", "0440", "CYRILLIC SMALL LETTER ER"],
  ["с", "0441", "CYRILLIC SMALL LETTER ES"],
  ["т", "0442", "CYRILLIC SMALL LETTER TE"],
  ["у", "0443", "CYRILLIC SMALL LETTER U"],
  ["ф", "0444", "CYRILLIC SMALL LETTER EF"],
  ["х", "0445", "CYRILLIC SMALL LETTER HA"],
  ["ц", "0446", "CYRILLIC SMALL LETTER TSE"],
  ["ч", "0447", "CYRILLIC SMALL LETTER CHE"],
  ["ш", "0448", "CYRILLIC SMALL LETTER SHA"],
  ["щ", "0449", "CYRILLIC SMALL LETTER SHCHA"],
  ["ъ", "044A", "CYRILLIC SMALL LETTER HARD SIGN"],
  ["ы", "044B", "CYRILLIC SMALL LETTER YERU"],
  ["ь", "044C", "CYRILLIC SMALL LETTER SOFT SIGN"],
  ["э", "044D", "CYRILLIC SMALL LETTER E"],
  ["ю", "044E", "CYRILLIC SMALL LETTER YU"],
  ["я", "044F", "CYRILLIC SMALL LETTER YA"],
  ["ѐ", "0450", "CYRILLIC SMALL LETTER IE WITH GRAVE"],
  ["ё", "0451", "CYRILLIC SMALL LETTER IO"],
  ["ђ", "0452", "CYRILLIC SMALL LETTER DJE"],
  ["ѓ", "0453", "CYRILLIC SMALL LETTER GJE"],
  ["є", "0454", "CYRILLIC SMALL LETTER UKRAINIAN IE"],
  ["ѕ", "0455", "CYRILLIC SMALL LETTER DZE"],
  ["і", "0456", "CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"],
  ["ї", "0457", "CYRILLIC SMALL LETTER YI"],
  ["ј", "0458", "CYRILLIC SMALL LETTER JE"],
  ["љ", "0459", "CYRILLIC SMALL LETTER LJE"],
  ["њ", "045A", "CYRILLIC SMALL LETTER NJE"],
  ["ћ", "045B", "CYRILLIC SMALL LETTER TSHE"],
  ["ќ", "045C", "CYRILLIC SMALL LETTER KJE"],
  ["ѝ", "045D", "CYRILLIC SMALL LETTER I WITH GRAVE"],
  ["ў", "045E", "CYRILLIC SMALL LETTER SHORT U"],
  ["џ", "045F", "CYRILLIC SMALL LETTER DZHE"],
];

export default entities;
